<template>
  <div class="wrap">
    <el-date-picker class="search" v-model="queryParams.dealtime" type="monthrange" value-format="yyyy-MM" start-placeholder="开始日期" end-placeholder="结束日期" @change="onSearch()" />
    <el-input v-model="queryParams.dealer" placeholder="更多经销商查询" class="input-with-select">
      <el-button slot="append" icon="el-icon-search" @click="moreSearch()"></el-button>
    </el-input>
    <el-card :body-style="{ padding: '0px' }" shadow="never" v-loading="loading">
      <el-scrollbar>
        <div class="toolbar total">
          <h3 class="name">经销商合计</h3>
          <el-link class="value" @click="onSearch({ region: null, category: null })">+{{ datalist.total }}</el-link>
        </div>
        <dl>
          <dd v-for="(row, index) in datalist.categorys" :key="'c' + index" @click="onSearch({ category: row.name })" :class="{ current: queryParams.category == row.name }">
            <span class="index">{{ index + 1 }}</span>
            <span class="name">{{ row.name }}</span>
            <span class="value">{{ row.value }}</span>
          </dd>
        </dl>
        <dl>
          <dd v-for="(row, index) in datalist.regions" :key="'r' + index" @click="onSearch({ region: row.name })" :class="{ current: queryParams.region == row.name }">
            <span class="index">{{ index + 1 }}</span>
            <span class="name">{{ row.name }}</span>
            <span class="value">{{ row.value }}</span>
          </dd>
        </dl>
      </el-scrollbar>
    </el-card>
    <dealerChart ref="chart" :params="queryParams" style="grid-row-start: span 2" />
  </div>
</template>

<script>
export default {
  components: {
    dealerChart: () => import('./charts/_dealer.vue')
  },
  data () {
    return {
      loading: false,
      datalist: { total: 0, categorys: [], regions: [] },
      queryParams: {}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    moreSearch () {
      this.$router.push({ path: "detail", query: { dealer: this.queryParams.dealer } })
    },
    onSearch (key) {
      this.queryParams = { ...this.queryParams, ...key }
      this.$refs.chart.queryParams = { ...this.$refs.chart.queryParams, ...this.queryParams }
      this.$refs.chart.loadData()
      this.loadData()
    },
    loadData () {
      if (this.loading) { return }
      this.loading = true
      this.$apis.trend.dealer.group(this.queryParams).then(res => {
        this.datalist = {
          total: res.total,
          categorys: this.$utils.common.DataGroup(res.data, "category").map(row => {
            return {
              name: row.type,
              value: row.items.reduce((acc, cur) => {
                return acc + cur.value
              }, 0)
            }
          }),
          regions: this.$utils.common.DataGroup(res.data, "region").map(row => {
            return {
              name: row.type,
              value: row.items.reduce((acc, cur) => {
                return acc + cur.value
              }, 0)
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 300px 1fr;
  grid-template-rows: auto 1fr;
  grid-gap: 16px;
  position: relative;

  .search {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 99;
  }

  .total {
    padding: 15px 20px;
    background: #fff;
    position: sticky;
    top: 0;
  }

  dl {
    padding: 20px;
    dd + dd {
      margin-top: 20px;
    }
    dd {
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .index {
        background-color: #ccc;
        color: #fff;
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-right: 10px;
        display: inline-block;
        text-align: center;
      }
      &:first-child {
        .index {
          background: #f00;
        }
      }
      &.current {
        color: #409eff;
        .index {
          background: #409eff;
        }
      }
      .name {
        flex: 1;
      }
      .value {
        &::after {
          content: '家';
          font-size: 50%;
        }
      }
    }
  }
}
</style>